import { Box, Card, Typography } from '@mui/material';
import { FC } from 'react';
import { ReportProblemOutlined } from '@mui/icons-material';
import { SxProps } from '@mui/system';

type Props = {
  serviceMessage?: string;
};

const classes: SxProps = {
  heading: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
  },
  card: {
    border: 'none',
    boxShadow: 'none',
    backgroundColor: '#f5f5f5',
  },
  icon: {
    marginLeft: -1,
  },
};

export const ServiceCardContent: FC<Props> = ({ serviceMessage }) => {
  return (
    <>
      <Box mr={3}>
        <Box sx={classes.col}>
          <ReportProblemOutlined fontSize="medium" sx={classes.icon} />
        </Box>
      </Box>
      <Box sx={classes.col}>
        <Typography variant="subtitle1">{serviceMessage}</Typography>
      </Box>
    </>
  );
};

export const ServiceCard: FC = ({ children }) => {
  return (
    <Card sx={classes.card}>
      <Box sx={classes.heading} px={3} py={1}>
        {children}
      </Box>
    </Card>
  );
};
